import { createFileRoute } from '@tanstack/react-router';

import { ForgotPasswordPage } from '@/features/portal/auth/ForgotPasswordPage';

export const Route = createFileRoute('/portal/auth/forgot-password/')({
  component: ForgotPasswordPage,
});
